export const tokenOptions = {
  KioskSite: [1, 0, 0, 0],
  SuperAdmin: [1 << 1, 0, 0, 0],
  Debug: [1 << 2, 0, 0, 0],
  RequestDetails: [1 << 3, 0, 0, 0],
  Common: [1 << 4, 0, 0, 0],
  Sql: [1 << 5, 0, 0, 0],
  Warning: [1 << 6, 0, 0, 0],
  AccessForbidden: [1 << 7, 0, 0, 0],
  BusinessLogic: [1 << 8, 0, 0, 0],
  Request: [1 << 9, 0, 0, 0],
  UserEditYourself: [1 << 10, 0, 0, 0],
  FrontEnd: [1 << 11, 0, 0, 0],
  Employees: [1 << 12, 0, 0, 0],
  EvacuationMessages: [1 << 13, 0, 0, 0],
  MessageDetails: [1 << 14, 0, 0, 0],
  InfoSearch: [1 << 15, 0, 0, 0],
  InfoSearchSites: [1 << 16, 0, 0, 0],
  InfoSearchAreas: [1 << 17, 0, 0, 0],
  InfoSearchPatients: [1 << 18, 0, 0, 0],
  RealTime: [1 << 19, 0, 0, 0],
  TalkBase: [1 << 20, 0, 0, 0],
  MqDeskTable: [1 << 21, 0, 0, 0],
  AdminSettings: [1 << 22, 0, 0, 0],
  SkipSms: [1 << 23, 0, 0, 0],
  SkipEmail: [1 << 24, 0, 0, 0],
  EditorLog: [1 << 25, 0, 0, 0], // 33554432
  QueueLines: [1 << 26, 0, 0, 0], // 67108864
  Roles: [1 << 27, 0, 0, 0], // 134217728
  PreserveLogSetting: [1 << 28, 0, 0, 0], // 268435456
  SitePages: [1 << 29, 0, 0, 0], // 536870912
  Sites: [1 << 30, 0, 0, 0], // 1073741824
  SiteSettings: [1 << 31, 0, 0, 0], // 2147483648
  // Int32
  Statistics: [0, 1, 0, 0], // 4294967296
  TemplatePages: [0, 1 << 1, 0, 0], // 8589934592
  Templates: [0, 1 << 2, 0, 0], // 17179869184
  Empty16: [0, 1 << 3, 0, 0], // 34359738368
  Users: [0, 1 << 4, 0, 0], // 68719476736
  Empty17: [0, 1 << 5, 0, 0], // 137438953472
  Visitors: [0, 1 << 6, 0, 0], // 274877906944
  PreRegisterView: [0, 1 << 7, 0, 0], // 549755813888
  Empty18: [0, 1 << 8, 0, 0], // 1099511627776
  Empty19: [0, 1 << 9, 0, 0], // 2199023255552
  Empty20: [0, 1 << 10, 0, 0], // 4398046511104
  Empty21: [0, 1 << 11, 0, 0], // 8796093022208
  Empty22: [0, 1 << 12, 0, 0], // 17592186044416
  Empty23: [0, 1 << 13, 0, 0], // 35184372088832

  // Second double word
  Empty53: [0, 0, 0x1, 0],
  Empty54: [0, 0, 0x2, 0],
  Empty24: [0, 0, 0x4, 0],
  Empty25: [0, 0, 0x8, 0],
  Empty26: [0, 0, 0x10, 0], // 16
  Empty27: [0, 0, 0x20, 0], // 32
  Empty28: [0, 0, 0x40, 0], // 64
  Empty29: [0, 0, 0x80, 0], // 128
  Empty30: [0, 0, 0x100, 0], // 256
  Empty31: [0, 0, 0x200, 0], // 512
  Empty32: [0, 0, 0x400, 0], // 1024
  Empty33: [0, 0, 0x800, 0], // 2048
  EmployeesWrite: [0, 0, 0x1000, 0], // 4096
  Empty34: [0, 0, 0x2000, 0], // 8192
  EmployeeExtensionsWrite: [0, 0, 0x4000, 0], // 16384 - Employee properties that are not bound to Azure AD
  InfoSearchWrite: [0, 0, 0x8000, 0], // 32768 - InfoSearch Categories & Statistics
  InfoSearchSitesWrite: [0, 0, 0x10000, 0], // 65536
  InfoSearchAreasWrite: [0, 0, 0x20000, 0], // 131072
  InfoSearchPatientsWrite: [0, 0, 0x40000, 0], // 262144
  Empty35: [0, 0, 0x80000, 0], // 524288
  Empty36: [0, 0, 0x100000, 0], // 1048576
  Empty37: [0, 0, 0x200000, 0], // 2097152
  Empty38: [0, 0, 0x400000, 0], // 4194304
  Empty39: [0, 0, 0x800000, 0], // 8388608
  Empty40: [0, 0, 0x1000000, 0], // 16777216
  Empty41: [0, 0, 0x2000000, 0], // 33554432
  QueueLinesWrite: [0, 0, 0x4000000, 0], // 67108864
  RolesWrite: [0, 0, 0x8000000, 0], // 134217728
  Empty42: [0, 0, 0x10000000, 0], // 268435456
  SitePagesWrite: [0, 0, 0x20000000, 0], // 536870912
  SitesWrite: [0, 0, 0x40000000, 0], // 1073741824
  Empty43: [0, 0, 0x80000000, 0], // 2147483648
  // Int32
  Empty44: [0, 0, 0, 0x1], // 4294967296
  TemplatePagesWrite: [0, 0, 0, 0x2], // 8589934592
  TemplatesWrite: [0, 0, 0, 0x4], // 17179869184
  Empty45: [0, 0, 0, 0x8], // 34359738368
  UsersWrite: [0, 0, 0, 0x10], // 68719476736
  Empty46: [0, 0, 0, 0x20], // 137438953472
  Empty47: [0, 0, 0, 0x40], // 274877906944
  PreRegister: [0, 0, 0, 0x80], // 549755813888
  Empty48: [0, 0, 0, 0x100], // 1099511627776
  Empty49: [0, 0, 0, 0x200], // 2199023255552
  Empty50: [0, 0, 0, 0x400], // 4398046511104
  Empty51: [0, 0, 0, 0x800], // 8796093022208
  Empty52: [0, 0, 0, 0x1000], // 17592186044416
};
export const FullLog = ["Debug", "RequestDetails", "FrontEnd", "Common", "Sql", "Warning", "AccessForbidden", "BusinessLogic", "Request",
  "RealTime", "TalkBase", "MqDeskTable", "AdminSettings", "SkipSms", "SkipEmail", "EditorLog", "PreserveLogSetting"];

export function checkPermission(prm, permit) {
  return permit?.length === 4 && (
    (prm[0] === 0 || (prm[0] & permit[0]) !== 0) &&
    (prm[1] === 0 || (prm[1] & permit[1]) !== 0) &&
    (prm[2] === 0 || (prm[2] & permit[2]) !== 0) &&
    (prm[3] === 0 || (prm[3] & permit[3]) !== 0)
  );
};

export const permissions = {
  None: 0,
  KioskSite: 1,
  SuperAdmin: 2,
  FullLog: 3,
  CompanySettings: 4,
  Companies: 5,
  MultiQueue: 6,
  KioskMonitor: 7,
  CreateCompany: 8,
  DropInNotifications: 9,
  DropInDepartments: 10,
  UserEditYourself: 11,
  EmployeeNotifications: 12,
  Employees: 13,
  EvacuationMessages: 14,
  CompanyLogo: 15,
  InfoSearch: 16,
  InfoSearchSites: 17,
  InfoSearchAreas: 18,
  InfoSearchPatients: 19,
  JobDepartments: 20,
  SkipNotifications: 21,
  AzureAD: 22,
  MeetingRooms: 23,
  CustomEmployeeSync: 24,
  Notifications: 25,
  VisitExpressSites: 26,
  QueueLines: 27,
  Roles: 28,
  Barcodes: 29,
  SitePages: 30,
  Sites: 31,
  SiteSettings: 32,
  Statistics: 33,
  TemplatePages: 34,
  Templates: 35,
  UserActivities: 36,
  Users: 37,
  VisitorNotifications: 38,
  Visitors: 39,
  PreRegisterView: 40,
  Entur: 41,
  EasyPark: 42,
  Taxi: 43,
  ProconEvent: 44,
  VisitorsList: 45,
  CompanyAgreement: 46,
  SMSsettings: 47,
  VisitExpressMessages: 48,
  DropInDepartmentsCreate: 49,
  CompaniesWrite: 50,
  EmailSettings: 51,
  MultiQueueSettings: 52,
  ExternalEmployee: 53,
  DropInNotificationsWrite: 54,
  DropInDepartmentsEdit: 55,
  DropInUsersWrite: 56,
  EmployeeNotificationsWrite: 57,
  EmployeesWrite: 58,
  EvacuationMessagesWrite: 59,
  EmployeeExtensionsWrite: 60,
  InfoSearchWrite: 61,
  InfoSearchSitesWrite: 62,
  InfoSearchAreasWrite: 63,
  InfoSearchPatientsWrite: 64,
  JobDepartmentsWrite: 65,
  JobTitlesWrite: 66,
  WorkingTime: 67,
  MeetingRoomsWrite: 68,
  MeetingServicesWrite: 69,
  NotificationsWrite: 70,
  TelenorStyle: 71,
  QueueLinesWrite: 72,
  RolesWrite: 73,
  EmployeesWriteExternal: 74,
  SitePagesWrite: 75,
  SitesWrite: 76,
  TeamMessages: 77,
  WaitCallback: 78,
  TemplatePagesWrite: 79,
  TemplatesWrite: 80,
  OpenDoor: 81,
  UsersWrite: 82,
  VisitorNotificationsWrite: 83,
  VisitorNotificationsLimitedWrite: 84,
  PreRegister: 85,
  EnturWrite: 86,
  EasyParkWrite: 87,
  TaxiWrite: 88,
  ProconEventWrite: 89,
  VisitExpress: 90,
  DashboardCarousel: 91,
  DropInDepartmentsDelete: 92,
  SitesEditMinimal: 93,
  BroadcastEmployeeSMS: 94,
  EmployeeEvacuation: 95,
  PreRegisterAlwaysNotifyEmployee: 96,
  QueueCallerModern: 97,
};
